export const MAP_SIZES_TO_PROPS = ({ width }) => ({
  isMobile: width <= 768,
  isTablet: width >= 769 && width <= 1023,
  isDesktop: width >= 1024 && width <= 1449,
  isExtraLargeDesktop: width >= 1450
})

/*These mirror the Bulma Breakpoints*/
